import { normalizeSlotLabel } from "./slotLabel.js";

export type ImpliedVariantRule = {
  slot: string;
  variantCode: string;
};

const IMPLY_PREFIX = "imply:";

export function isImpliedVariantTag(tag: string): boolean {
  return tag.trim().toLowerCase().startsWith(IMPLY_PREFIX);
}

export function parseImpliedVariantTag(tag: string): ImpliedVariantRule | null {
  const raw = tag.trim();
  if (!isImpliedVariantTag(raw)) return null;
  const body = raw.slice(IMPLY_PREFIX.length);
  const splitAt = body.indexOf(":");
  if (splitAt <= 0) return null;
  const slot = normalizeSlotLabel(body.slice(0, splitAt));
  const variantCode = body.slice(splitAt + 1).trim();
  if (!slot || !variantCode) return null;
  return { slot, variantCode };
}

export function parseImpliedVariantTags(tags: readonly string[]): ImpliedVariantRule[] {
  const out: ImpliedVariantRule[] = [];
  const seen = new Set<string>();
  for (const tag of tags) {
    const rule = parseImpliedVariantTag(tag);
    if (!rule) continue;
    const key = `${rule.slot}\0${rule.variantCode.toLowerCase()}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(rule);
  }
  return out;
}

export function formatImpliedVariantTag(rule: ImpliedVariantRule): string {
  const slot = normalizeSlotLabel(rule.slot);
  const variantCode = rule.variantCode.trim();
  if (!slot || !variantCode) return "";
  return `${IMPLY_PREFIX}${slot}:${variantCode}`;
}

export function mergeImpliedRulesIntoTags(
  tags: readonly string[],
  rules: readonly ImpliedVariantRule[],
): string[] {
  const kept = tags.filter((tag) => !isImpliedVariantTag(tag));
  const imply = rules.map(formatImpliedVariantTag).filter((tag) => tag.length > 0);
  return [...kept, ...imply];
}
